import { render, staticRenderFns } from "./NewsDetails.vue?vue&type=template&id=7878dd9c&scoped=true&"
import script from "./NewsDetails.vue?vue&type=script&lang=js&"
export * from "./NewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetails.vue?vue&type=style&index=0&id=7878dd9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7878dd9c",
  null
  
)

export default component.exports